import { render, staticRenderFns } from "./CustomerInvoiceCard.vue?vue&type=template&id=3bafa5e5&"
import script from "./CustomerInvoiceCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerInvoiceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports